/**
 * @generated SignedSource<<2f4faf55255a1ecb5e7332503ef9a5ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IsUserLoggedInQuery$variables = {};
export type IsUserLoggedInQuery$data = {
  readonly me: {
    readonly profile: {
      readonly isVerified: boolean;
      readonly firstName: string | null;
      readonly lastName: string | null;
    };
  };
};
export type IsUserLoggedInQuery = {
  variables: IsUserLoggedInQuery$variables;
  response: IsUserLoggedInQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileInfo",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IsUserLoggedInQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IsUserLoggedInQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c68f894a107df484b092e2529af52467",
    "id": null,
    "metadata": {},
    "name": "IsUserLoggedInQuery",
    "operationKind": "query",
    "text": "query IsUserLoggedInQuery {\n  me {\n    profile {\n      isVerified\n      firstName\n      lastName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa19f0b0bef718573e154fdc3c65f274";

export default node;
